import React from 'react';
import VisitorLog from './VisitorLog';

const Visitors: React.FC<any> = () => {
  return (
    <div>
      <VisitorLog />
    </div>
  );
};

export default Visitors;
